<template>
  <div class="kanban-column">
    <div class="kanban-column__wrapper">
      <div data-no-dragscroll class="kanban-column__header">
        <slot name="header" />
        <div v-if="isDragDisabled" class="kanban-column__drag-disabled-indicator">
          <small class="text-muted">
            <b-icon icon="lock-fill" font-scale="0.8"></b-icon>
            Перенос недоступен
          </small>
        </div>
      </div>

      <Draggable
        ref="draggable"
        class="kanban-column__list"
        :class="{ 'kanban-column__list--disabled': isDragDisabled }"
        group="kanban"
        v-model="column.items"
        ghost-class="ghost"
        :fallbackTolerance="5"
        :sort="false"
        :scroll-sensitivity="100"
        :force-fallback="true"
        :disabled="isDragDisabled"
        @change="$emit('moved', { ...$event, column })"
      >
        <b-skeleton-wrapper
          ref="skeleton"
          class="h-100 d-flex align-items-center justify-content-center"
          :loading="loading"
        >
          <slot v-if="column.items.length > 0" name="item" />

          <template #loading>
            <b-icon
              style="animation-duration: 0.3s"
              variant="primary"
              icon="three-dots"
              animation="cylon"
              font-scale="4"
            ></b-icon>
          </template>
        </b-skeleton-wrapper>
      </Draggable>
    </div>

    <slot name="nested" />
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
  },

  props: {
    column: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasNestedSlot() {
      return !!this.$slots.nested;
    },
    isDragDisabled() {
      return (this.column.kanban_meta && this.column.kanban_meta.disable_drag) || false;
    },
  },
};
</script>

<style lang="scss" scoped src="~/components/ui/kanban/KanbanColumn.scss" />
